import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  OnInit, Optional,
  ViewContainerRef
} from "@angular/core";
import {IntPortalOutletService} from "./int-portal-outlet.service";

@Component({
  selector: 'int-portal-outlet, [intPortalOutlet]',
  templateUrl: './int-portal-outlet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: []
})
export class IntPortalOutletComponent implements OnInit {

  templates$ = this.portalService.templates$

  constructor(
    private readonly containerRef: ViewContainerRef,
    @Optional()
    private readonly portalService: IntPortalOutletService
  ) {
    if(this.portalService) {
      this.portalService.setRoot(this.containerRef);
    }
  }

  ngOnInit() {

  }

}
